import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import Loadable from 'ui-component/Loadable';
import PublicShipmentLayout from 'layout/PublicShipmentLayout';
import AuthGuard from 'utils/route-guard/AuthGuard';

// render - new shipment page
const NewShipment = Loadable(lazy(() => import('features/shipments/components/NewShipmentPage')));

// ==============================|| SHIPMENT PUBLIC ROUTING ||============================== //

const ShipmentRoutes: RouteObject = {
  path: '/',
  element: <PublicShipmentLayout />,
  children: [
    {
      path: '/nuevo-envio',
      // TODO: ruta era pública para permitir armar envío antes de login (flujo pre-auth).
      // Desactivado temporalmente — requiere sesión. Reactivar removiendo AuthGuard
      // y restaurando lógica pendingShipment en GuestGuard y useNewShipmentController.
      element: (
        <AuthGuard>
          <NewShipment />
        </AuthGuard>
      )
    }
  ]
};

export default ShipmentRoutes;
